import { render, staticRenderFns } from "./maincomp.vue?vue&type=template&id=59d12f7e&scoped=true&"
import script from "./maincomp.vue?vue&type=script&lang=js&"
export * from "./maincomp.vue?vue&type=script&lang=js&"
import style0 from "./maincomp.vue?vue&type=style&index=0&id=59d12f7e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59d12f7e",
  null
  
)

export default component.exports